import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import HeaderLayout from './header/HeaderLayout';
import FooterLayout from './footer/FooterLayout';
import HelmetWrap from './dom-elements/HelmetWrap';
import { setRouterState, setCatPage } from './../redux/actions';
import { page_meta_defaults } from './../_DATA.json';

class Layout extends Component {

  componentWillMount() {
    this._routeData(this.props.routeData, this.props.matchData);
    this.props.setCatPage(this.props.routeData.pathname);
  }

  componentWillReceiveProps(nextProps) {
    this._routeData(nextProps.routeData, nextProps.matchData);
    this.props.setCatPage(nextProps.routeData.pathname);
  }

  _routeData(location, match) {
    this.props.setRouterData({
      location_data: location,
      match_data: match
    });
  }

  render() {
    return (
      <Fragment>
        {(this.props.staticContent) &&
          <Fragment>
            <HeaderLayout location={this.props.routeData}/>
              <HelmetWrap pageMeta={page_meta_defaults} />
              {this.props.children}
            <FooterLayout socialLinks={this.props.staticContent.homeData.data.social_links}/>
          </Fragment>
        }
      </Fragment>
    );
  };
};

export default connect(
  state => ({
    staticContent: state.staticContent
  }),
  dispatch => ({
    setRouterData: (data) => dispatch(setRouterState(data)),
    setCatPage: (url) => dispatch(setCatPage(url))
  })
)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout.js